import { HOLIDAY_PACKAGE_SORT, type HolidayPackageSort } from '@/src/constants/holidays'
import type { HolidayPackageSummary } from '@/src/types/holidays'

export const sortHolidayPackages = (
    packages: HolidayPackageSummary[],
    sort: HolidayPackageSort,
    locale: string
): HolidayPackageSummary[] => {
    const sorted = [...packages]

    if (sort === HOLIDAY_PACKAGE_SORT.PRICE_LOW_TO_HIGH) {
        return sorted.sort((a, b) => a.startingPrice.amount - b.startingPrice.amount)
    }
    if (sort === HOLIDAY_PACKAGE_SORT.PRICE_HIGH_TO_LOW) {
        return sorted.sort((a, b) => b.startingPrice.amount - a.startingPrice.amount)
    }

    const collator = new Intl.Collator(locale, { sensitivity: 'base' })
    return sorted.sort((a, b) => collator.compare(a.destinationName, b.destinationName))
}
